type Props = {
  text: string
};

function TinyText({ text = '' }: Props) {
  return <small className="font-bolder break-all">{text}</small>;
}

export default TinyText;
